import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface LTLCarrierSearchItem {
  tradingPartnerId: number;
  tradingPartnerName: string;
  tradingPartnerNum: string;
  scac: string;
  mccNum: string;
  active: boolean;
}

export type GetLTLCarriersSearchResponse = {
  carriers: LTLCarrierSearchItem[];
};

export async function getLTLCarriersSearch(
  search: string,
  isForceRefresh = true
): Promise<Result<GetLTLCarriersSearchResponse, ApiError>> {
  try {
    const response = await axios.get<GetLTLCarriersSearchResponse>(
      '/quote/ltl/carriers/search',
      {
        params: {
          search: search.trim() || undefined,
        },
        headers: {
          isForceRefresh: String(isForceRefresh),
        },
      }
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLTLCarriersSearch' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to search LTL carriers' });
    }

    return err({
      message: error.response?.data?.message || 'Failed to search LTL carriers',
    });
  }
}
